/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Descriptionfallback1Inputs */

const ja_metadata_descriptionfallback1 = /** @type {(inputs: Metadata_Descriptionfallback1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAINは、ゲームマーケティングやインフルエンサーマーケティング、ゲーム関連のWebプロダクトやECサービスの開発・運営を行っています。また、eスポーツイベントの制作・運営も主要な事業として展開しています。`)
};

const en_metadata_descriptionfallback1 = /** @type {(inputs: Metadata_Descriptionfallback1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN engages in game marketing, influencer marketing, and the development and operation of game-related web products and e-commerce services. Additionally, the production and management of esports events are also major aspects of our business.`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN engages in game marketing, influencer marketing, and the development and operation of game-related web products and e-commerce services. Additional..." |
*
* @param {Metadata_Descriptionfallback1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const metadata_descriptionfallback1 = /** @type {((inputs?: Metadata_Descriptionfallback1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Descriptionfallback1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_metadata_descriptionfallback1(inputs)
	return en_metadata_descriptionfallback1(inputs)
});
export { metadata_descriptionfallback1 as "metadata_descriptionFallback" }